import React from 'react';
import { useT } from '@repo/common';
import FaqSideItem from './FaqSideItem';

const FaqSide = ({ selectedSlug, onSelect, topics }) => {
  const t = useT();
  return (
    <div className='flex flex-col items-start w-[160px] gap-4'>
      <div className='typo-b18Strong text-text-primary'>
        {t('Topics', '주제')}
      </div>
      <div className='flex flex-col items-start gap-3 w-full'>
        {topics.map((topic) => (
          <FaqSideItem
            key={topic.id}
            topic={topic}
            isSelected={selectedSlug === topic.slug}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
};

export default FaqSide;
